module.exports = __webpack_public_path__ + "static/img/185.62bc4c0d.png";